






import Vue from 'vue';
import ITokenResponse from '../models/auth/ITokenResponse';

export default Vue.extend({
    
    methods: {
        click() {
            
            let url = "http://localhost:8080/login";
            url += "?app-id=dd7ae839-c4dc-42c4-8c94-145915ed09c6";

            const oAuthWindow = window.open(url, "dv.devlin.auth", "width=400,height=600,menubar=no");
            if (!oAuthWindow) {
                throw 'Failed to open window';
            }
            
            let resolved = false;
            window.onmessage = (event: MessageEvent) => {
                if (event.origin !== window.location.origin) {
                    return;
                }

                const authResult = <ITokenResponse>event.data;
                if (!authResult.accessToken) {
                    return;
                }

                if (authResult.accessToken) {
                    // TODO
                    console.log(authResult);
                    resolved = true;
                    oAuthWindow.close();
                }
            };

            // https://stackoverflow.com/a/48240128
            let timer = setInterval(() => {
                if (oAuthWindow.closed) {
                    clearInterval(timer);

                    if (resolved) {
                        return;
                    }

                    console.error('Login cancelled');
                }
            }, 1000);
        },
    },
});
